import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { ReplyCommentState } from '../../state/states/reply-comment.state';
import { MarkdownService } from '../../../markdown/markdown.service';
import { ReportDialogComponent } from '../report-dialog/report-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'reply-comment',
  templateUrl: './reply-comment.component.html',
  styleUrls: ['./reply-comment.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ReplyCommentComponent implements OnInit {
  @Input() replyCommentState: ReplyCommentState;
  @Input() currentUser: MiniUserModel;

  @Output() upVoteReply = new EventEmitter();
  @Output() downVoteReply = new EventEmitter();
  @Output() deleteActionReply = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    private markdownService: MarkdownService
  ) {}

  ngOnInit(): void {
    console.log(this.replyCommentState);
  }

  downVoteComment(): void {
    this.downVoteReply.emit();
  }

  upVoteComment(): void {
    this.upVoteReply.emit();
  }

  deleteComment(): void {
    this.deleteActionReply.emit(this.replyCommentState.comment.Id);
  }

  reportComment(): void {
    const dialogref = this.dialog.open(ReportDialogComponent, {
      data: {
        title: `Report Comment`,
        message: `Describe the reason you are reporting this Comment.`
      }
    });
  }

  showMarkDown(doc: string): string {
    return this.markdownService.convertMarkDownForDisplay(doc);
  }
}
